import { useFeatureFlags } from '@brightdrop/feature-flags-client';
import { EMER_FLAG } from '~/common/models/featureFlags.model';

/**
 * Whether the full-page notification settings are on. They ship with EMER,
 * behind its flag; while it is off, notification settings keep the list pages
 * and the edit dialog.
 * @returns True while the EMER flag is on
 */
export const useNotificationSettingsFullPage = (): boolean => {
  const { getFlag } = useFeatureFlags();
  return !!getFlag(EMER_FLAG);
};
